const currentYear = new Date().getFullYear();

const MIN_YEAR = currentYear - 100;

const MAX_YEAR = currentYear + 100;

const STANDARD_DATE_FORMAT = 'YYYY-MM-DD';

const STANDARD_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const DISPLAYED_DATE_FORMAT = 'DD/MM/YYYY';

const DISPLAYED_TIMESTAMP_FORMAT = 'DD/MM/YYYY HH:mm:ss';

const DISPLAYED_DATE_HM_FORMAT = 'DD/MM/YYYY HH:mm';

const DISPLAYED_DATE_HMS_FORMAT = 'DD/MM/YYYY HH:mm:ss';

export {
    MIN_YEAR,
    MAX_YEAR,
    STANDARD_DATE_FORMAT,
    STANDARD_DATE_TIME_FORMAT,
    DISPLAYED_DATE_FORMAT,
    DISPLAYED_TIMESTAMP_FORMAT,
    DISPLAYED_DATE_HM_FORMAT,
    DISPLAYED_DATE_HMS_FORMAT,
}
